import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  const user = (() => {
    try { return JSON.parse(localStorage.getItem("user")); }
    catch { return null; }
  })();

  // Belum login → redirect ke login yang sesuai
  if (!token || !user) {
    const isSuperadminRoute = allowedRoles?.includes("superadmin");
    const isAdminRoute      = allowedRoles?.includes("admin");

    if (isSuperadminRoute || isAdminRoute) {
      return <Navigate to="/admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  const roleName = user.role?.name;

  // Sudah login tapi role tidak diizinkan
  if (allowedRoles && !allowedRoles.includes(roleName)) {
    // Redirect ke dashboard sesuai role yang dimiliki
    if (roleName === "superadmin") return <Navigate to="/superadmin" replace />;
    if (roleName === "admin")      return <Navigate to="/admin" replace />;
    if (roleName === "user")       return <Navigate to="/user" replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
}